import { ArrowUpRightIcon } from '@heroicons/react/24/outline';
import { FC, useState } from 'react';

import { Dialog, DialogPanel, DialogTitle } from 'primitives/Dialog';

import { ExampleTemplateComponent } from './HelperComponents';

const ExampleTemplate: FC = () => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <>
      <div
        className="w-full text-indigo-600 text-sm flex space-x-1 items-center cursor-pointer"
        onClick={() => setOpen(true)}
      >
        <span>Certificate Example</span>
        <span>
          <ArrowUpRightIcon className="w-4 h-4" />
        </span>
      </div>
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
      >
        <DialogPanel className="min-w-[720px]">
          <DialogTitle>Example Template</DialogTitle>
          <ExampleTemplateComponent />
        </DialogPanel>
      </Dialog>
    </>
  );
};

export default ExampleTemplate;
